import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import logo from './image/logo.png';
import { loginUser, redirectToPortal } from '../../config/api';
import './PortalVirtual.css';

const PortalVirtual: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Limpiar cualquier rastro de sesión anterior al mostrar el login,
  // incluyendo restauraciones desde bfcache (botón "atrás")
  React.useEffect(() => {
    const clearSession = () => {
      localStorage.clear();
      sessionStorage.clear();
    };

    clearSession();

    // bfcache: el navegador restaura la página sin recargarla
    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) clearSession();
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const data = await loginUser(email, password);
      redirectToPortal(data.access, data.refresh);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  }, [email, password]);

  return (
    <div className="portal-page">
      <div className="portal-particles">
        {[...Array(18)].map((_, i) => (
          <div
            key={i}
            className="portal-particle"
            style={{
              '--delay': `${Math.random() * 4}s`,
              '--duration': `${3 + Math.random() * 4}s`,
              '--size': `${2 + Math.random() * 4}px`,
              '--x': `${Math.random() * 100}%`,
              '--y': `${Math.random() * 100}%`,
            } as React.CSSProperties}
          />
        ))}
      </div>

      <div className="portal-card">
        <div className="portal-info">
          <img src={logo} alt="CECAP" className="portal-logo" />
          <h1>CECAP <span>Maicao</span></h1>
          <p>
            Accede al portal administrativo para gestionar información,
            procesos y recursos institucionales de CECAP.
          </p>
        </div>

        <div className="portal-form-section">
          <span className="portal-badge">Acceso administrativo</span>
          <h2 className="portal-form-title">Portal Administrativo</h2>
          <p className="portal-form-sub">Ingresa con tu correo y contraseña institucional.</p>

          <form onSubmit={handleSubmit} className="portal-form">
            <div className="portal-field">
              <label htmlFor="email">Correo electrónico</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError('');
                }}
                required
                placeholder="tu@correo.com"
                autoComplete="email"
              />
            </div>

            <div className="portal-field">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError('');
                }}
                required
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>

            {error && <div className="portal-error">{error}</div>}

            <button type="submit" disabled={loading} className="portal-submit">
              {loading ? 'Iniciando sesión...' : 'Ingresar al portal'}
            </button>
          </form>

          <div className="portal-back">
            <Link to="/">← Volver al inicio</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalVirtual;
